import React from "react";

import { useDispatch, useSelector } from "react-redux";
import Notificationes from "../Notificaciones/Notificaciones";
import {
  ContenedorHeader,
  HeaderBar,
  HeaderBarUl,
  HeaderBarLi,
  HeaderBarLink,
  HeaderPlanInfo,
  HeaderPlanToggle,
  HeaderPlanBadge,
  HeaderPlanMenu,
  HeaderPlanMenuItem,
} from "./styles";
import { auth } from "../../services/firebase/Config";
import { setUsuarioSesion } from "../../redux/sesion/sesionActions";
import { setPacienteSesion } from "../../redux/sesion/sesionActions";
import { newPaciente } from "../../redux/paciente/pacienteActions";
import { clearAtencionActiva } from "../../redux/atenciones/atencionesActions";
import HeaderProfileItem from "./HeaderProfileItem/HeaderProfileItem";
import Spinner from "react-bootstrap/Spinner";
import { useLocalStorage } from "../../hooks/useLocalStorage";
import Badge from "react-bootstrap/Badge";
import Button from "react-bootstrap/Button";
import { ConfirmacionSiNoModal } from "../ConfirmacionSiNoModal/index";

export const Header = () => {
  const dispatch = useDispatch();
  const [, setUsuario] = useLocalStorage("usuario");
  const empresa = useSelector((state) => state.empresa);
  const sesion = useSelector((state) => state.sesion);
  const [showConfirmModal, setShowConfirmModal] = React.useState(false);
  const [menuOpen, setMenuOpen] = React.useState(false);

  const getMensaje = () => {
    return `Su periodo de prueba finaliza en ${getDiasPrueba()} dias`;
  };

  const getDiasPrueba = () => {
    let dias = 0;
    if (empresa.tipoMembresia === "DEMO") {
      let fechaTermino = new Date();
      if (empresa.fechaIngreso instanceof Date)
        fechaTermino = empresa.fechaIngreso.getDate() + 15;
      if (fechaTermino > new Date().getDate())
        dias = fechaTermino - new Date().getDate();
    }
    return dias;
  };
  //const logoImg = require(`../../img/logos/${sesion.usuario.empresa.logoNombre}`);
  const atencionActiva = useSelector(
    (state) => state.atenciones.atencionActiva,
  );

  const onConfirmLogout = () => {
    dispatch(setUsuarioSesion(null));
    dispatch(setPacienteSesion(false));
    dispatch(newPaciente());
    dispatch(clearAtencionActiva());
    setUsuario();
    auth.signOut();
    window.location.href = "/";
  };

  const handleCloseSesion = () => {
    if (atencionActiva) {
      setShowConfirmModal(true);
      return;
    }
    onConfirmLogout();
  };

  const togglePlanMenu = () => {
    setMenuOpen((current) => !current);
  };

  const closePlanMenu = () => {
    setMenuOpen(false);
  };
  if (sesion.loading || sesion.loading === undefined) {
    return (
      <Spinner animation="border" role="status">
        <span className="visually-hidden"></span>
      </Spinner>
    );
  }
  return (
    sesion.usuario && (
      <header>
        <ContenedorHeader>
          <HeaderBar>
            <HeaderBarUl>
              <HeaderBarLi>
                <HeaderPlanInfo>
                  <HeaderPlanToggle onClick={togglePlanMenu} type="button">
                    <span>Plan</span>
                    <HeaderPlanBadge>
                      {empresa?.tipoMembresia?.toUpperCase() || "FREE"}
                    </HeaderPlanBadge>
                  </HeaderPlanToggle>
                  {menuOpen && (
                    <HeaderPlanMenu>
                      <HeaderPlanMenuItem
                        to="/admin/planes"
                        onClick={closePlanMenu}
                      >
                        Cambiar plan
                      </HeaderPlanMenuItem>
                    </HeaderPlanMenu>
                  )}
                </HeaderPlanInfo>
              </HeaderBarLi>
              <Notificationes />

              <HeaderProfileItem
                onCloseSesion={handleCloseSesion}
                mensaje={getMensaje()}
              />
            </HeaderBarUl>
          </HeaderBar>
        </ContenedorHeader>
        <ConfirmacionSiNoModal
          isOpen={showConfirmModal}
          handleCloseModal={() => setShowConfirmModal(false)}
          onClickYes={onConfirmLogout}
          mensaje="Tiene una atención clínica activa. ¿Está seguro de que desea cerrar sesión? Se recomienda finalizar la atención primero."
        />
      </header>
    )
  );
};
